import {BaseModel} from "./BaseModel";

export class AttachmentsModel extends BaseModel {
    constructor(cookie = "") {
        super();
        this.cookie = cookie;

    }

    RouteName = "Attachment";
    AuthState = true;

    async GetAttachments(type, pageNumber, pageSize = 10) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/GetAttachments?type=${type}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }
    async DeleteAttachment(id) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/DeleteAttachment?id=${id}`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }
    async UploadFile(model) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/UploadFile`, model,{
                    headers:{
                        'Content-Type': 'multipart/form-data'
                    }
                });
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    DownloadFile(id) {
        return `${this.baseApi.baseUrl}/${this.baseApi.version}/${this.RouteName}/DownloadFile?id=${id}`
        
    }
}
